/**
 * Bloc toggle object
 */
var accordion = {
  params : {
      accordionContainer: '',
      accordionContents: [],
      accordionToggle: '',
      accordionSubtoggle: ''
	},

	init : function(options){
		this.params = $.extend(this.params,options);
    that = this;

    this.params.accordionSubtoggle.slideUp();

    // open first item
    if(this.params.accordionSubtoggle[0]) {
      $(this.params.accordionSubtoggle[0]).slideDown(300).addClass('open');
      $(this.params.accordionToggle[0]).addClass('active');
    }

    this.params.accordionToggle.on('click',function() {
      if( $(this).hasClass('active') ) {
        accordion.closeDropdowns();
      } else {
        accordion.openDropdown($(this).next());
        $(this).addClass('active');
      }
    })


	},

  handleClick : function(link, index) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      this.params.accordionContainer.openDropdown(index);
    });
  },

  closeDropdowns : function() {
    $(accordion.params.accordionToggle).removeClass('active');
    $(accordion.params.accordionSubtoggle).slideUp(300).removeClass('open');
  },

  openDropdown : function(dropdown) {
    accordion.closeDropdowns();
    dropdown.slideDown(300).addClass('open');
  },

  toggleDropdown : function(event) {
    var toggleDropdown = $(event.currentTarget);
    if( toggleDropdown.hasClass("active") ){
      accordion.closeDropdowns();
    } else {
      accordion.openDropdown(toggleDropdown);
    }
  }

}
